import { z } from "zod";
/**
 * The assertion WordPress makes about a signed-in shopper.
 *
 * Minimal on purpose. It answers exactly one question — "who is looking at this
 * page right now" — and carries nothing capable of expressing authorization. A
 * compromised WordPress instance can therefore impersonate a customer, which is
 * inherent in designating it the identity provider, but it cannot grant staff
 * roles or permissions: no claim here can express them.
 *
 * See `docs/architecture/wordpress-integration.md` for the full contract.
 */
export const handoffTokenClaimsSchema = z.object({
    /** Expected to equal `WP_HANDOFF_ISSUER`. */
    iss: z.string().min(1),
    aud: z.union([z.string(), z.array(z.string())]),
    /** WordPress user id, as a string, mirroring `wp`. */
    sub: z.string().min(1),
    /** WordPress user id. The identity anchor: stable, unlike email. */
    wp: z.number().int().positive(),
    email: z.email(),
    iat: z.number(),
    /**
     * 60 seconds after `iat` by default. Short enough that a token scraped from a
     * rendered page is near-useless, long enough to survive page load.
     */
    exp: z.number(),
    /** Single-use nonce. Claimed atomically in Redis to prevent replay. */
    jti: z.string().min(1),
});
/** Extract the identity from verified claims. Verification happens in `@island/auth-tokens`. */
export function handoffIdentityFromClaims(claims) {
    return { wordpressUserId: claims.wp, email: claims.email };
}
//# sourceMappingURL=handoff.js.map